export function incrementStringInSrc(cartProducts, src) {
  let newSrc = src;

  cartProducts.forEach(products => {
    products.forEach((product, index) => {
      newSrc += `&cd[contents][${index + 1}][id]=${
        product.codigo_produto
      }&cd[contents][${index + 1}][quantity]=${product.quantidade}`;
    });
  });

  return newSrc;
}
